module.exports = __webpack_public_path__ + "img/icono-acreditacion.6cdcc832.svg";